<div class="autocomplete">
    <div class="input-icon">
        <input *ngIf="!isProduct" 
               [(ngModel)]="input" 
               class="form-control" 
               type="text"
               (keyup)="getAllItems()"
               placeholder="{{placeholder || 'Pretraži'}}">
        <input *ngIf="isProduct" 
               [(ngModel)]="searchTerm" 
               class="form-control" 
               type="text"
               (keyup)="getAllItems()"
               placeholder="{{placeholder || 'Pretraži'}}">
        <div class="input-icon-addon">
            <i class="fe fe-search"></i>
        </div>
    </div>

    <div class="autocomplete__list" *ngIf="isListVisible">
        <div class="autocomplete__item"
             *ngFor="let item of items; trackBy: trackByFn"
             (click)="onSelect(item)">
            {{ item.nonStandardMaterialId || item.materialId }}-{{ item.name }}
        </div>
    </div>
</div>
